export default {
  bright: "#2ADBEF",
  dark: "#212121",
  light: "rgba(255,255,255,1)",
}
